// extracted by mini-css-extract-plugin
export default {"explorer":"new-menu_explorer__-OAor","carousel":"new-menu_carousel__8XVTp","carousel__category":"new-menu_carousel__category__aF+hG"};